<template>
  <section class="container">
    <div class="p-3">
      <h5 class="text-center m-0 text-darked">
        {{ problemName }}
      </h5>
      <b-link class="text-center d-block mt-2" @click="modalSave = true">
        <i class="material-icons align-middle">
          present_to_all
        </i>
        <p class="m-0 d-inline align-middle">
          Save configuration
        </p>
      </b-link>
    </div>
    <div v-if="Object.keys(getChangesByCategory).length" class="antecedents">
      <div v-for="(value, categoryId, index) in getChangesByCategory" :key="index">
        <ListAntecedents
          :title="categoryNamesById[categoryId]"
          :antecedents="value"
          color="#929FA4"
        />
      </div>
    </div>

    <div class="px-3">
      <hr class="my-0" />
      <h5 class="my-3 text-uppercase text-center">
        Try it out!
      </h5>
      <p class="pb-3 mx-lg-5">
        Learn more about specific strategies for each skill and set goals around these skills.
      </p>
    </div>
    <!-- Results skills list -->
    <skill-list :options="getSkillList" />

    <!-- Button Edit Child Challenge -->
    <div class="container-edit-btn">
      <custom-button
        router
        :to="{ name: 'challengeSelectChild', query: { next: 'challenge-parent-approve' } }"
        class="px-4 btn-edit-challenge"
        >Edit Child Challenge</custom-button
      >
    </div>

    <!-- Modal create new Criteria -->
    <b-modal
      v-model="modalSave"
      size="sm"
      ref="modal"
      :title="problemName"
      centered
      @hidden="resetModalSave"
    >
      <b-input
        type="text"
        v-model="configurationName"
        placeholder="Problem name"
        class="mb-2"
      ></b-input>
      <!-- Button save criterion -->
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="warning"
            block
            @click="createNewConfiguration()"
            :disabled="!configurationName || configurationName == ''"
          >
            Save
          </b-button>
        </div>
      </template>
      <!-- /Button save criterion -->
    </b-modal>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import skillList from '@/components/help/skillList.vue';
import CustomButton from '@/components/general/CustomButton.vue';
import ListAntecedents from '@/components/help/ListAntecedents.vue';
import mixinNotificationToast from '@/mixins/notificationToast.mixin.js';

export default {
  components: {
    skillList,
    CustomButton,
    ListAntecedents,
  },
  props: {
    problemName: String,
    problemId: [String, Number],
  },
  mixins: [mixinNotificationToast],
  data() {
    return {
      modalSave: false,
      configurationName: null,
    };
  },
  methods: {
    ...mapActions('help', ['CreateNewConfiguration']),
    resetModalSave() {
      this.configurationName = '';
    },
    changesSendAPIAdapter(categoryIds = [], getChangesByCategory = {}) {
      return categoryIds.map((categoryId) => ({
        category_id: categoryId,
        changes_ids: getChangesByCategory[categoryId].map((change) => change.value),
      }));
    },
    createNewConfiguration() {
      this.modalSave = false;
      const skills = this.getSkillList.map((skill) => skill.id);
      const categoryIds = Object.keys(this.getChangesByCategory);
      const changes = this.changesSendAPIAdapter(categoryIds, this.getChangesByCategory);
      try {
        this.CreateNewConfiguration({
          skills,
          parent: this.getUserId,
          configName: this.configurationName,
          problem: this.problemId,
          changes,
        });
        this.notificationToast({
          message: 'Saved successfully.',
          variant: 'success',
          title: 'Problem Solving',
        });
      } catch (error) {
        this.notificationToast({
          message: 'Sorry, an error has occurred.',
          variant: 'error',
          title: 'Problem Solving',
        });
      }
    },
    findItemsById(targetIds, items, fieldId = 'id') {
      if (!targetIds || !targetIds.length) return false;

      return targetIds.map((id) => items.find((item) => item[fieldId] === id));
    },
    createAntecedent(title, antecedents, color) {
      return { title, antecedents, color };
    },
  },
  computed: {
    ...mapGetters('help', [
      'getSkillList',
      'getCauseList',
      'getChangeList',
      'getChangesByCategory',
    ]),
    ...mapGetters('user', ['getUserId']),
    categoryNamesById() {
      const categories = this.getChangeList.map((change) => change.category);
      const categoriesNamesById = categories.reduce(
        (acc, categorie) => ({ ...acc, [categorie.id]: categorie.name }),
        {},
      );
      return categoriesNamesById;
    },
  },
};
</script>

<style scope lang="scss">
.container-edit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-edit-challenge {
  margin-top: 2rem;

  font-weight: bold !important;
}

.antecedents {
  padding: 0 3rem;
  display: flex;
  flex-direction: column;
}
</style>
